import React from 'react';
import ReactDOM from 'react-dom/client';
import LoadingIndicator from './components/LoadingIndicator';
import { fullpageloginRootId, cancelButtonContainerId } from './constants';

/* Render LoadingIndicator component to hidden div. Visibility of this div is toggled when loading indicator needs to be displayed. */
const content = document.getElementById(fullpageloginRootId);
const spinner = document.createElement('div');
spinner.style.display = 'none';
spinner.setAttribute('role', 'alert');
spinner.setAttribute('aria-busy', 'true');
spinner.setAttribute('aria-describedBy', 'loading-indicator-description');

const spinnerRoot = ReactDOM.createRoot(spinner);
spinnerRoot.render(
    <React.StrictMode>
        <LoadingIndicator />
    </React.StrictMode>
);
document.body.appendChild(spinner);

/* React components can use this class to toggle global loading indicator. */
class LoadingIndicatorImpl {
    set(loading, duringVerification) {
        const footer = document.getElementById('fullpagelogin-footer');
        const cancelButton = document.getElementById(cancelButtonContainerId);
        if (loading) {
            if (duringVerification) {
                hide(cancelButton);
                hide(footer);
            } else {
                hide(content);
                show(spinner);
            }
        } else {
            hide(spinner);
            show(cancelButton);
            show(footer);
            show(content);
        }
        console.debug('loading indicator:', loading);
    }
}

const show = (e) => {
    if (e) {
        e.style.display = 'block';
    }
};

const hide = (e) => {
    if (e) {
        e.style.display = 'none';
    }
};

const loadingIndicator = new LoadingIndicatorImpl();
export default loadingIndicator;
